import { Table, TableBody } from "@material-ui/core";
import React from "react";

import {
    EnhancedRow,
    EnhancedTableHead,
    EnhancedTableToolbar,
    TableColumn,
    TableOptions,
    useEnhancedTableStyles,
} from "./";

interface EnhancedTableProps {
    data: any[];
    columns: TableColumn[];
    options: TableOptions;
    selectedRows?: string[];
    dataCy: string;
}

export const EnhancedTable = (props: EnhancedTableProps) => {
    const classes = useEnhancedTableStyles(props);
    const { data, columns, options, dataCy, selectedRows = [] } = props;
    const {
        onDeselectAll,
        onSelectAll,
        onRequestSort,
        onRowChecked,
        onRowUnchecked,
        onSelectedAction,
        color = "default",
        order = "asc",
        orderBy = "id",
        titleVariant = "h4",
        title,
        actionComponent,
        actions,
        hideCheckbox,
        toolbarClassName,
        rowBody,
        checkboxDisabled,
    } = options;

    const handleSelectedAction = (action: string) => {
        onSelectedAction?.(action);
    };

    const handleSelectAllClick = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        if (event.target.checked) {
            onSelectAll?.();
        } else {
            onDeselectAll?.();
        }
    };

    const handleClick = (
        event: React.ChangeEvent<HTMLInputElement>,
        id: string
    ) => {
        if (event.target.checked) {
            onRowChecked?.(id);
        } else {
            onRowUnchecked?.(id);
        }
    };

    const getIsSelected = (id: string) =>
        !!id && !!selectedRows && selectedRows.indexOf(id.toString()) !== -1;

    const idField = columns[0].field;
    let idCount = 0;
    let idPrefix = "";
    //Used for interview table; If there is a startDateTime on the data obj the compare to now to proper prefix;
    if (data[0]?.startDateTime) {
        idPrefix =
            Date.parse(data[0].startDateTime) < Date.now()
                ? "past"
                : "upcoming";
    }
    const showToolbar =
        !!actionComponent ||
        (title && title.length > 0) ||
        (selectedRows && selectedRows.length > 0);

    return (
        <div className={classes.root}>
            {showToolbar ? (
                <EnhancedTableToolbar
                    color={color}
                    numSelected={selectedRows.length}
                    onSelectedAction={handleSelectedAction}
                    actions={actions}
                    actionComponent={actionComponent}
                    toolbarClassName={toolbarClassName}
                    title={title}
                    titleVariant={titleVariant}
                />
            ) : null}
            <div className={classes.tableWrapper}>
                <Table aria-labelledby="tableTitle" padding="default" data-cy={dataCy}>
                    <EnhancedTableHead
                        columns={columns}
                        rowCount={data.length}
                        numSelected={selectedRows.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={onRequestSort}
                        hideCheckbox={hideCheckbox}
                        checkboxColor={color}
                        isExpansion={!!rowBody}
                        boldColumnHeaders={options.boldColumnHeaders}
                        checkboxDisabled={checkboxDisabled}
                    />
                    <TableBody>
                        {data.map((n, tri) => {
                            const isSelected = getIsSelected(n[idField]);
                            idCount++;

                            return (
                                <EnhancedRow
                                    key={tri}
                                    row={n}
                                    dataCy={dataCy}
                                    columns={columns}
                                    hideCheckbox={hideCheckbox}
                                    isSelected={isSelected}
                                    color={color}
                                    idField={idField}
                                    tableRowIndex={tri}
                                    handleClick={handleClick}
                                    idPrefix={idPrefix}
                                    idCount={idCount}
                                    rowBody={rowBody}
                                    boldColumnValues={options.boldColumnValues}
                                    checkboxDisabled={checkboxDisabled}
                                />
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};
